export function Ratio4x5Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="16.25" y="18.125" width="12.5" height="16.25" rx="2" transform="rotate(-180 16.25 18.125)" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio4x5Icon.displayName = 'Ratio4x5Icon';
